import React, { useState } from 'react';
import authService from '../../servicios/authService';
import ConfiguracionNotificaciones from './ConfiguracionNotificaciones';

function TabConfiguracion({
  usuarioActual,
  handleActualizarUsuario,
  showSavedPassword,
  setShowSavedPassword,
  teamMembers,
  onEmailCambiado
}) {
  const [editandoEmail, setEditandoEmail] = useState(false);
  const [emailNuevo, setEmailNuevo] = useState('');
  const [guardandoEmail, setGuardandoEmail] = useState(false);
  const [errorEmail, setErrorEmail] = useState('');
  const [emailGuardado, setEmailGuardado] = useState(false);
  const [datosPersonalesAbierto, setDatosPersonalesAbierto] = useState(false);
  const [cambiarPasswordAbierto, setCambiarPasswordAbierto] = useState(false);

  const handleIniciarEditEmail = () => {
    setEmailNuevo(usuarioActual?.email || '');
    setErrorEmail('');
    setEmailGuardado(false);
    setEditandoEmail(true);
  };

  const handleCancelarEditEmail = () => {
    setEditandoEmail(false);
    setEmailNuevo('');
    setErrorEmail('');
  };

  const handleGuardarEmail = async () => {
    const trimmed = emailNuevo.trim().toLowerCase();
    if (!trimmed) { setErrorEmail('Ingresa un correo válido'); return; }
    if (trimmed === (usuarioActual?.email || '').toLowerCase()) {
      setEditandoEmail(false);
      return;
    }
    setGuardandoEmail(true);
    setErrorEmail('');
    try {
      await authService.cambiarEmail(trimmed);
      setEditandoEmail(false);
      setEmailGuardado(true);
      if (onEmailCambiado) onEmailCambiado(trimmed);
      setTimeout(() => setEmailGuardado(false), 3000);
    } catch (err) {
      setErrorEmail(err.mensaje || err.message || 'Error al cambiar correo');
    } finally {
      setGuardandoEmail(false);
    }
  };

  return (
    <div className="tab-content config-page">
      <section className="progress-section-v2">
        <div className="critical-header-bar">
          <h2 className="config-page-title">Configuración</h2>
        </div>

        {/* Datos Personales */}
        <div className="config-card">
          <h3
            className={`config-card-title config-card-title-toggle ${datosPersonalesAbierto ? 'open' : ''}`}
            onClick={() => setDatosPersonalesAbierto(o => !o)}
          >
            Datos Personales
            <span className="config-card-chevron">▸</span>
          </h3>
          {datosPersonalesAbierto && (
          <form onSubmit={async (e) => {
            e.preventDefault();
            const formData = new FormData(e.target);
            const nombre = formData.get('nombre');
            
            try {
              await handleActualizarUsuario({ nombre });
              alert('Datos actualizados correctamente');
            } catch (error) {
              alert('Error al actualizar: ' + (error.mensaje || error.message));
            }
          }}>
            <div className="config-form-group">
              <label className="config-label" htmlFor="config-nombre">
                Nombre de Usuario
              </label>
              <input
                id="config-nombre"
                name="nombre"
                type="text"
                defaultValue={usuarioActual?.nombre || ''}
                placeholder="Tu nombre de usuario"
                required
                className="config-input"
              />
              <small className="config-hint">
                Este nombre se mostrará en la aplicación
              </small>
            </div>

            <div className="config-form-group">
              <label className="config-label" htmlFor="config-email">
                Correo Electrónico
              </label>
              {editandoEmail ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <input
                    id="config-email"
                    type="email"
                    value={emailNuevo}
                    onChange={e => setEmailNuevo(e.target.value)}
                    onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); handleGuardarEmail(); } if (e.key === 'Escape') handleCancelarEditEmail(); }}
                    autoFocus
                    className="config-input"
                    placeholder="nuevo@correo.com"
                    disabled={guardandoEmail}
                  />
                  {errorEmail && (
                    <small style={{ color: '#ef4444', fontSize: '12px' }}>{errorEmail}</small>
                  )}
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button
                      type="button"
                      onClick={handleGuardarEmail}
                      disabled={guardandoEmail}
                      style={{ padding: '6px 14px', background: '#111827', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '13px', cursor: guardandoEmail ? 'not-allowed' : 'pointer', opacity: guardandoEmail ? 0.7 : 1 }}
                    >
                      {guardandoEmail ? 'Guardando...' : 'Guardar'}
                    </button>
                    <button
                      type="button"
                      onClick={handleCancelarEditEmail}
                      disabled={guardandoEmail}
                      style={{ padding: '6px 14px', background: 'transparent', color: '#6b7280', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', cursor: 'pointer' }}
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <input
                    id="config-email"
                    type="email"
                    value={usuarioActual?.email || ''}
                    disabled
                    className="config-input-disabled gray"
                    style={{ flex: 1 }}
                  />
                  <button
                    type="button"
                    onClick={handleIniciarEditEmail}
                    title="Cambiar correo"
                    style={{ padding: '8px 12px', background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0 }}
                  >
                    ✏️ Editar
                  </button>
                </div>
              )}
              {emailGuardado && (
                <small style={{ color: '#16a34a', fontSize: '12px' }}>✓ Correo actualizado correctamente</small>
              )}
              {!editandoEmail && !emailGuardado && (
                <small className="config-hint">Haz clic en Editar para cambiar tu correo</small>
              )}
            </div>

            <div className="config-form-group">
              <label className="config-label" htmlFor="config-tipo">
                Tipo de Usuario
              </label>
              <input
                id="config-tipo"
                type="text"
                value={
                  usuarioActual?.tipoUsuario === 'propietario' ? 'Propietario del Proyecto' :
                  usuarioActual?.tipoUsuario === 'miembro' ? 'Miembro del Equipo' :
                  'Propietario del Proyecto'
                }
                disabled
                className={`config-input-disabled ${usuarioActual?.tipoUsuario === 'propietario' ? 'blue' : 'indigo'}`}
              />
              <small className="config-hint">
                {usuarioActual?.tipoUsuario === 'propietario'
                  ? 'Eres el creador y propietario de este proyecto'
                  : 'Fuiste agregado como miembro del equipo'}
              </small>
            </div>

            <div className="config-form-group">
              <label className="config-label" htmlFor="config-rol">
                Nivel de Acceso
              </label>
              <input
                id="config-rol"
                type="text"
                value={
                  usuarioActual?.rol === 'admin' ? 'Administrador' :
                  usuarioActual?.rol === 'superadmin' ? 'Super Administrador' :
                  'Usuario'
                }
                disabled
                className="config-input-disabled amber"
              />
              <small className="config-hint">
                Define tus permisos en la aplicación
              </small>
            </div>

            {/* Mostrar cargo si es miembro del equipo */}
            {usuarioActual?.tipoUsuario === 'miembro' && (() => {
              const miembro = teamMembers.find(m => {
                if (m.usuario) {
                  const usuarioId = typeof m.usuario === 'object' ? m.usuario._id : m.usuario;
                  if (usuarioId === usuarioActual?._id || usuarioId === usuarioActual?.id) {
                    return true;
                  }
                }
                if (m.email && usuarioActual?.email && m.email.toLowerCase() === usuarioActual.email.toLowerCase()) {
                  return true;
                }
                return false;
              });
              
              const cargo = miembro?.cargo || miembro?.role || 'No asignado';
              
              return (
                <div className="config-form-group">
                  <label className="config-label" htmlFor="config-cargo">
                    Cargo en el Equipo
                  </label>
                  <input
                    id="config-cargo"
                    type="text"
                    value={cargo}
                    disabled
                    className="config-input-disabled green"
                  />
                  <small className="config-hint">
                    Tu rol específico en el proyecto
                  </small>
                </div>
              );
            })()}

            {/* Campo de contraseña visible */}
            {(() => {
              const savedPassword = localStorage.getItem('userPwd') || '';
              
              return savedPassword && (
                <div className="config-password-box">
                  <div style={{ marginBottom: '10px' }}>
                    <span className="config-password-label">
                      Tu Contraseña
                    </span>
                    <span className="config-password-sublabel">
                      Pulsa el botón para mostrar u ocultar
                    </span>
                  </div>
                  <div className="config-password-display">
                    <span className={`config-password-text ${showSavedPassword ? 'visible' : 'hidden'}`}>
                      {showSavedPassword ? savedPassword : '•'.repeat(Math.max(savedPassword.length, 8))}
                    </span>
                    <button
                      type="button"
                      onClick={() => setShowSavedPassword(!showSavedPassword)}
                      className={`config-password-toggle ${showSavedPassword ? 'active' : ''}`}
                    >
                      {showSavedPassword ? 'Ocultar' : 'Mostrar'}
                    </button>
                  </div>
                  {showSavedPassword && (
                    <div className="config-password-warning">
                      Asegúrate de que nadie más esté viendo tu pantalla
                    </div>
                  )}
                </div>
              );
            })()}

            <button
              type="submit"
              className="config-submit-btn"
            >
              Guardar Cambios
            </button>
          </form>
          )}
        </div>

        {/* Cambiar Contraseña */}
        <div className="config-card">
          <h3
            className={`config-card-title config-card-title-toggle ${cambiarPasswordAbierto ? 'open' : ''}`}
            onClick={() => setCambiarPasswordAbierto(o => !o)}
          >
            Cambiar Contraseña
            <span className="config-card-chevron">▸</span>
          </h3>
          {cambiarPasswordAbierto && (
          <form onSubmit={async (e) => {
            e.preventDefault();
            const formData = new FormData(e.target);
            const passwordActual = formData.get('passwordActual');
            const passwordNuevo = formData.get('passwordNuevo');
            const passwordConfirmar = formData.get('passwordConfirmar');

            if (passwordNuevo.length < 6) {
              alert('La nueva contraseña debe tener al menos 6 caracteres');
              return;
            }

            if (passwordNuevo !== passwordConfirmar) {
              alert('Las contraseñas nuevas no coinciden');
              return;
            }

            try {
              await handleActualizarUsuario({ passwordActual, passwordNuevo }, true);
              alert('Contraseña actualizada correctamente');
              e.target.reset();
            } catch (error) {
              alert('Error: ' + (error.mensaje || error.message));
            }
          }}>
            <div className="config-form-group">
              <label className="config-label" htmlFor="config-password-actual">
                Contraseña Actual
              </label>
              <input
                id="config-password-actual"
                name="passwordActual"
                type="password"
                placeholder="Tu contraseña actual"
                required
                className="config-input"
              />
            </div>

            <div className="config-form-group">
              <label className="config-label" htmlFor="config-password-nuevo">
                Nueva Contraseña
              </label>
              <input
                id="config-password-nuevo"
                name="passwordNuevo"
                type="password"
                placeholder="Mínimo 6 caracteres"
                required
                minLength={6}
                className="config-input"
              />
            </div>

            <div className="config-form-group">
              <label className="config-label" htmlFor="config-password-confirmar">
                Confirmar Nueva Contraseña
              </label>
              <input
                id="config-password-confirmar"
                name="passwordConfirmar"
                type="password"
                placeholder="Repite la nueva contraseña"
                required
                className="config-input"
              />
            </div>

            <div className="config-security-tip">
              <p>
                <strong>Consejo de seguridad:</strong> Usa una contraseña única que no utilices en otros sitios.
              </p>
            </div>

            <button
              type="submit"
              className="config-submit-btn orange"
            >
              Cambiar Contraseña
            </button>
          </form>
          )}
        </div>

        <ConfiguracionNotificaciones usuarioActual={usuarioActual} />
      </section>
    </div>
  );
}

export default TabConfiguracion;
